/* Zymirhub: scroll reveal + accessible accordions. No dependencies. */
(function () {
  'use strict';

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.zh-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function setOpen(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) {
      panel.setAttribute('data-open', open ? 'true' : 'false');
      panel.toggleAttribute('inert', !open);
    }
  }

  function initAccordions(root) {
    (root || document).querySelectorAll('[data-zh-accordion]').forEach(function (group) {
      if (group.dataset.zhReady) return;
      group.dataset.zhReady = '1';
      var single = group.hasAttribute('data-single');
      var buttons = Array.prototype.slice.call(group.querySelectorAll('.zh-faq__btn'));
      buttons.forEach(function (btn, i) {
        setOpen(btn, btn.getAttribute('aria-expanded') === 'true');
        btn.addEventListener('click', function () {
          var willOpen = btn.getAttribute('aria-expanded') !== 'true';
          if (single && willOpen) buttons.forEach(function (b) { if (b !== btn) setOpen(b, false); });
          setOpen(btn, willOpen);
        });
        btn.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown') next = buttons[(i + 1) % buttons.length];
          else if (e.key === 'ArrowUp') next = buttons[(i - 1 + buttons.length) % buttons.length];
          else if (e.key === 'Home') next = buttons[0];
          else if (e.key === 'End') next = buttons[buttons.length - 1];
          if (next) { e.preventDefault(); next.focus(); }
        });
      });
    });
  }

  function initCardForms(root) {
    (root || document).querySelectorAll('form[data-zh-add]').forEach(function (form) {
      if (form.dataset.zhReady) return;
      form.dataset.zhReady = '1';
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      });
    });
  }

  function init(root) { initReveal(root); initAccordions(root); initCardForms(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
